<template>
  <el-row>
    <el-col :span="24">
      <div class="gs-menu">
        <el-menu background-color="#324157" text-color="#ffffff" active-text-color="#FFD037" :router="true"
          :default-active="$route.path.split('/')[1] || 'dashboard'" mode="horizontal">
          <el-menu-item index="" class="gs-logo gs-border-none"><router-link to="/"><img src="/static/goship-w.png"
                alt="1Express Express"></router-link></el-menu-item>
          <el-menu-item index="dashboard" class="gs-menu-item" active>
            <router-link :to="{ name: 'dashboard' }">Bảng điều khiển</router-link>
          </el-menu-item>
          <!-- <el-menu-item index="receipt" class="gs-menu-item"><router-link :to="{name: 'receipt'}">Phiếu thu</router-link></el-menu-item> -->
          <el-menu-item index="cross-checks" class="gs-menu-item">
            <router-link :to="{ name: 'cross-check' }">Phiên đối soát</router-link>
          </el-menu-item>
          <el-menu-item index="invoices" class="gs-menu-item"><router-link :to="{ name: 'invoice' }">Phiếu
              chi</router-link></el-menu-item>
          <el-menu-item index="compares" class="gs-menu-item">
            <router-link :to="{ name: 'compare' }">Đơn đối soát</router-link>
          </el-menu-item>
          <el-submenu index="5" class="gs-menu-item">
            <template slot="title"><span style="font-size: 15px">Admin</span></template>
            <el-menu-item index="users">
              <router-link :to="{ name: 'user' }" class="text-white text-remove-decoration"><i
                  class="fa fa-user margin-right"></i>
                User</router-link>
            </el-menu-item>
            <el-menu-item index="roles">
              <router-link :to="{ name: 'role' }" class="text-white text-remove-decoration"><i
                  class="fa fa-cog margin-right"></i>
                Role</router-link>
            </el-menu-item>
            <el-menu-item index="permissions">
              <router-link :to="{ name: 'permission' }" class="text-white text-remove-decoration"><i
                  class="fa fa-cogs margin-right"></i> Permission</router-link>
            </el-menu-item>
          </el-submenu>
          <!-- <el-menu-item index="salers" class="gs-menu-item">
            <router-link :to="{ name: 'saler' }">Salers</router-link>
          </el-menu-item>
          <el-menu-item index="affiliates" class="gs-menu-item">
            <router-link :to="{ name: 'affiliate' }">Affiliate</router-link>
          </el-menu-item> -->
          <div class="header-right gs-border-none pull-right padding-lg-right padding-lg-left">
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon-setting icon-header"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <a @click="logOut()" class="text-blue"><i class="fa fa-sign-out" aria-hidden="true"></i> Logout</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a @click.prevent="changePassword()" class="text-blue"><i class="fa fa-key" aria-hidden="true"></i> Đổi
                    mật khẩu</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="header-right gs-border-none pull-right padding-lg-right padding-lg-left">
            <el-popover ref="popover" width="200" trigger="hover">
              <h3 class="text-center text-blue remove-margin">Thông tin tài khoản</h3>
              <p><i class="fa fa-user"></i> {{ accountInfo.name }}</p>
              <p><i class="fa fa-phone"></i> {{ accountInfo.phone }}</p>
              <p><i class="fa fa-envelope-o"></i> {{ accountInfo.email }}</p>
            </el-popover>
            <i class="fa fa-user-circle-o icon-header" v-popover:popover></i>
          </div>
        </el-menu>
        <el-dialog title="Đổi mật khẩu" :visible.sync="changePasswordModal">
          <el-form :rules="rules" ref="changePasswordForm" :model="account" label-width="120px"
            @submit.prevent.native="validateBeforeSubmit" label-position="top">
            <el-form-item label="Mật khẩu hiện tại" class="padding-login-item" prop="old_password">
              <el-input type="password" v-model="account.old_password" placeholder="Mật khẩu hiện tại"></el-input>
            </el-form-item>
            <el-form-item label="Mật khẩu mới" class="padding-login-item" prop="password">
              <el-input type="password" v-model="account.password" placeholder="Mật khẩu mới"></el-input>
            </el-form-item>
            <el-form-item label="Nhập lại mật khẩu" prop="password_confirmation">
              <el-input type="password" v-model="account.password_confirmation"
                placeholder="Nhập lại mật khẩu"></el-input>
            </el-form-item>
            <el-form-item class="padding-login-item">
              <el-button type="primary" native-type="submit" class="width-100"><i class="fa fa-floppy-o"></i> Lưu
                lại</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { changePassword } from 'src/api/accounts'
import { head } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
export default {

  name: 'GsMenu',

  data() {
    let comfirmPass = (rule, value, callback) => {
      if (value !== this.account.password) {
        callback(new Error('Nhập lại mật khẩu không đúng'))
      } else {
        callback()
      }
    }
    return {
      active: '',
      changePasswordModal: false,
      account: {
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      rules: {
        old_password: [
          {
            required: true,
            message: 'Mật khẩu hiện tại không được để trống',
            trigger: 'change'
          },
          {
            min: 6,
            max: 32,
            message: 'Mật khẩu hiện tại phải trong khoảng 6 đến 32 ký tự',
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: 'Mật khẩu mới không được để trống',
            trigger: 'change'
          },
          {
            min: 6,
            max: 32,
            message: 'Mật khẩu mới phải trong khoảng 6 đến 32 ký tự',
            trigger: 'change'
          }
        ],
        password_confirmation: [
          {
            required: true,
            message: 'Nhập lại mật khẩu không được để trống',
            trigger: 'change'
          },
          {
            validator: comfirmPass,
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  methods: {
    ...mapActions('account', ['getPersonlInformation']),
    validateBeforeSubmit() {
      this.$refs.changePasswordForm.validate(valid => {
        if (valid) {
          changePassword(this.account).then(response => {
            if (response.code === 200) {
              this.$store.dispatch('showNotify', {
                title: 'Đổi mật khẩu thành công',
                body: 'Đổi mật khẩu thành công'
              })
              this.$store.dispatch('logout')
              this.$router.push({ path: '/login' })
            }
            if (response.code === 422) {
              let er = response.data.errors
              let message = head(er)
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              })
              this.submitting = false
            }
          })
        } else {
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          this.submitting = false
          return false
        }
      })
    },
    logOut() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
      window.location.reload()
    },
    changePassword() {
      this.changePasswordModal = true
    }
  },
  mounted() {
    if (this.$router.currentRoute.name !== 'dashboard') {
      this.active = this.$router.currentRoute.fullPath.split('/')[1]
    }
    if (!Object.keys(this.accountInfo).length) {
      this.getPersonlInformation()
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'dashboard') {
        this.active = ''
      } else {
        this.active = to.fullPath.split('/')[1]
      }
    }
  }
}
</script>

<style lang="css" scoped>
.gs-menu .el-menu {
  padding: 0 70px;
  border-radius: 0;
}

.gs-logo img {
  height: 60px;
  margin-top: -10px;
}

.gs-logo {
  font-size: 20px;
  color: #c0ccda;
  padding-left: 15px;
}

.gs-logo a {
  font-size: 20px;
  text-decoration: none;
}

.el-menu--horizontal>.gs-border-none:hover {
  border-bottom: transparent;
}

.gs-menu-item {
  padding: 0;
}

.gs-menu-item a {
  text-decoration: none;
  font-size: 15px;
  display: block;
  padding: 0px 20px;
}

.gs-menu .el-menu-item.is-active {
  color: #c0ccda;
}

.gs-menu .el-menu-item.is-active:not(:first-child) {
  font-weight: bold;
  border-bottom: 5px solid #20a0ff;
}

.input-search {
  width: 280px !important;
  height: 36px;
}

.icon-header {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

.header-right {
  height: 60px;
  line-height: 60px;
}

.notify {
  min-width: 350px;
}

.notify .notify-item {
  line-height: 20px;
  font-size: 12px;
}

.notify .notify-item:hover {
  background: transparent;
}

@media (max-width: 475px) {
  .gs-menu-item {
    display: none;
  }

  .gs-menu .el-menu {
    padding: 0px 2px;
  }
}
</style>



// WEBPACK FOOTER //
// GsMenu.vue?4dff275c